import { useEffect, useState } from "react"
import { findClosestLocation } from "../../utils/location/nearestLocation"
import { useGetData } from "../getData/useGetData"
import { useGetLocation } from "../location/useGetLocation"
import { useRecoilState } from "recoil"
import { OrganisationUnitsState } from "../../atoms/orgunitsState"

const useGetDefaultOU = () => {
    const { getData } = useGetData()
    const { location } = useGetLocation()
    const [ous, setOus] = useRecoilState(OrganisationUnitsState)
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        if (location || location === undefined) {
            getData('organisationUnits/station/?pageSize=300')
                .then((stationResponse) => {
                    const closest = location ? findClosestLocation(location?.latitude, location?.longitude, stationResponse?.organizationUnits)
                        : stationResponse?.organizationUnits?.[0]

                    setOus({
                        ous: stationResponse?.organizationUnits,
                        defaultOu: closest
                    })
                    setLoading(false)
                })
        }
    }, [location])

    return { ous, loading }
}

export { useGetDefaultOU }